import { useTranslation } from 'next-i18next';

interface IBeddingSectionButton {
  buttonID: string;
  onHover: () => void;
  onHoverEnd: () => void;
}

const BeddingSectionButton = ({ buttonID, onHover, onHoverEnd }: IBeddingSectionButton) => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });
  return (
    <li className={buttonID}>
      <a
        href={tLink(buttonID)}
        onMouseEnter={onHover}
        onMouseLeave={onHoverEnd}
        aria-label={`${buttonID}: ${tButton('shopNow')}`}
      >
        <span>{buttonID}</span>
        <em>{tButton('shopNow')}</em>
      </a>
    </li>
  );
};

export default BeddingSectionButton;
